import { useFormikContext } from 'formik';
import React from 'react';
import { Button as ReactButton } from '@a-ui/react';
import { translate } from '../../../i18n';

interface EmailFormActionsProps {
  onCancel: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const EmailFormActions: React.FC<EmailFormActionsProps> = ({ onCancel }) => {
  const { isSubmitting } = useFormikContext();

  return (
    <ul className="m-button-list u-margin-top">
      <li>
        <ReactButton fullWidth htmlType="submit" disabled={isSubmitting}>
          {translate('common.button.next')}
        </ReactButton>
      </li>
      <li>
        <ReactButton fullWidth emphasis="medium" onClick={onCancel}>
          {translate('common.button.cancel')}
        </ReactButton>
      </li>
    </ul>
  );
};

export default EmailFormActions;
